const tabsNav = $('[data-tabs-nav]');
const tabsId = tabsNav.data('tabs-nav');
const mobile = $('[data-tabs-mobile]');

const tabNavItems = $('[data-tab-toggle]');
const tabs = $(`[data-tabs='${tabsId}'] [data-tab-id]`);
const active = 'active';

$(document).ready(() => {
  if (!tabsNav.length || !tabsId.length || !tabs.length || !tabNavItems.length) return;

  tabNavItems.first().addClass(active);
  tabs.first().addClass(active);

  bindClickEvents();

  $(window).resize(() => {
    if (matchMedia('(min-width: 991px)').matches) {
      bindClickEvents();
    }
  });
});


function bindClickEvents() {
  tabNavItems.click((e) => {
    if ((!mobile.length || mobile.data('tabs-mobile') === false)
      && matchMedia('(max-width: 991px)').matches) {
      return;
    }
    // remove active classes from nav
    tabNavItems.each((index, item) => {
      $(item).removeClass(active);
    });
    // remove active classes from items
    tabs.each((index, item) => {
      $(item).removeClass(active);
    });
    // add clicked to current item
    $(e.currentTarget).addClass(active);
    // find the id of the nav item clicked to lookup the tabs to show
    const clicked = $(e.currentTarget).data('tab-toggle');
    // add active class to the tab item to show
    tabs.filter(`[data-tab-id=${clicked}]`).addClass(active);
  });
}
